module.exports = __webpack_public_path__ + "img/g9.9178dab4.jpg";